/**
 * GABA Calm Pouches hero buy box — one-time / subscribe / annual purchase options,
 * with a plan-vs-buy-once mode toggle inside the annual panel. Bound once to
 * `document` so it survives section re-renders in the theme editor.
 *
 * All variant IDs and selling plan IDs come from data-* attributes rendered by
 * sections/product-pouches-hero.liquid (real product/selling-plan Liquid objects,
 * nothing hardcoded here) and are posted straight to /cart/add.js.
 */
(function () {
  if (window.__gcpBuyBox) {
    window.__gcpBuyBox.sync();
    return;
  }
  var CFG = (window.__gcpBuyBox = { sync: sync });

  function attr(el, n) {
    return (el && el.getAttribute(n)) || '';
  }
  function list(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function panelFor(box, opt) {
    return box.querySelector('[data-gcp-panel="' + attr(opt, 'data-gcp-opt') + '"]');
  }
  function optFor(box, panel) {
    var k = attr(panel, 'data-gcp-panel');
    return list(box, '.gcp-opt').filter(function (o) {
      return attr(o, 'data-gcp-opt') === k;
    })[0];
  }
  // an option's panel may hold mode buttons. The active mode wins, otherwise
  // the option itself carries the data.
  function sourceFor(box, opt) {
    var p = panelFor(box, opt);
    var m = p ? p.querySelector('.gcp-mode.is-active') : null;
    return m || opt;
  }
  function currentOpt(box) {
    var l = list(box, '.gcp-opt');
    return l.filter(function (o) { return attr(o, 'aria-checked') === 'true'; })[0] || l[0];
  }
  function showErr(box, msg) {
    var e = box.querySelector('[data-gcp-err]');
    if (e) {
      e.textContent = msg;
      e.classList.add('show');
    }
  }
  function hideErr(box) {
    var e = box.querySelector('[data-gcp-err]');
    if (e) e.classList.remove('show');
  }

  function render(box, opt) {
    var src = sourceFor(box, opt);
    var ctaLabel = box.querySelector('[data-gcp-cta-label]');
    var ctaPrice = box.querySelector('[data-gcp-cta-price]');
    var guarantee = box.querySelector('[data-gcp-guarantee-text]');

    if (ctaLabel) ctaLabel.textContent = attr(src, 'data-cta-label');
    if (ctaPrice) {
      var was = attr(src, 'data-cta-compare');
      ctaPrice.innerHTML =
        '<span class="now">' + attr(src, 'data-cta-price') + '</span>' +
        (was ? '<span class="was">' + was + '</span>' : '');
    }
    if (guarantee) guarantee.textContent = attr(src, 'data-guarantee');

    // a mode can rewrite the row's own price stack
    var rowNow = attr(src, 'data-row-now');
    var row = opt.querySelector('.gcp-price');
    if (row && rowNow) {
      var sfx = attr(src, 'data-row-suffix');
      var rWas = attr(src, 'data-row-was');
      var rPer = attr(src, 'data-row-per');
      row.innerHTML =
        '<span class="now">' + rowNow + (sfx ? '<em>' + sfx + '</em>' : '') + '</span>' +
        (rWas ? '<span class="was">' + rWas + '</span>' : '') +
        (rPer ? '<span class="per">' + rPer + '</span>' : '');
    }

    // and the panel's callout plus fine print
    var p = panelFor(box, opt);
    if (p) {
      var callout = p.querySelector('[data-gcp-callout]');
      var fine = p.querySelector('[data-gcp-finenote]');
      var lead = attr(src, 'data-callout-lead');
      if (callout && lead) callout.innerHTML = '<strong>' + lead + '</strong> ' + attr(src, 'data-callout-rest');
      if (fine && attr(src, 'data-finenote')) fine.textContent = attr(src, 'data-finenote');
    }
  }

  function select(box, opt) {
    var key = attr(opt, 'data-gcp-opt');
    list(box, '.gcp-opt').forEach(function (o) {
      o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
    });
    list(box, '.gcp-panel').forEach(function (p) {
      p.classList.toggle('is-open', attr(p, 'data-gcp-panel') === key);
    });
    hideErr(box);
    render(box, opt);
  }

  function setMode(box, mode) {
    var panel = mode.closest('[data-gcp-panel]');
    if (!panel) return;
    list(panel, '.gcp-mode').forEach(function (s) {
      var on = s === mode;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var owner = optFor(box, panel);
    hideErr(box);
    // only repaint if this mode belongs to the option that is selected, so a
    // hidden panel can never hijack the CTA
    if (owner && owner === currentOpt(box)) render(box, owner);
  }

  function openCart() {
    ['cart:refresh', 'cart:build', 'cart-updated', 'cart:updated'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    var selectors = [
      '[data-gcp-cart-trigger]', '#cart-icon-bubble', '.js-drawer-open-cart',
      '[data-cart-drawer-toggle]', '[data-drawer-open="cart"]', '#CartDrawer-Toggle',
      'a[href="/cart"][aria-haspopup]', '.header__icon--cart'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.click();
        return;
      }
    }
  }

  function addToCart(box) {
    var opt = currentOpt(box);
    if (!opt) return;
    var cta = box.querySelector('[data-gcp-cta]');
    var ctaLabel = box.querySelector('[data-gcp-cta-label]');
    var src = sourceFor(box, opt);
    var raw = attr(src, 'data-items');

    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      console.error('[gcp] could not parse data-items:', raw, e);
      showErr(box, 'This option is not configured yet.');
      return;
    }

    cta.classList.add('is-adding');
    cta.disabled = true;
    hideErr(box);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () { return {}; })
          .then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          });
      })
      .then(function (res) {
        cta.classList.remove('is-adding');
        cta.disabled = false;
        if (!res.ok) {
          console.error('[gcp] /cart/add.js rejected this', res.status, res.body, 'sent:', items);
          showErr(
            box,
            res.body.description || res.body.message ||
              'Add to cart failed with status ' + res.status + '. Details are in the console.'
          );
          return;
        }
        openCart();
        if (ctaLabel) {
          ctaLabel.textContent = 'Added';
          setTimeout(function () {
            var c = currentOpt(box);
            if (c) ctaLabel.textContent = attr(sourceFor(box, c), 'data-cta-label');
          }, 1300);
        }
      })
      .catch(function (e) {
        cta.classList.remove('is-adding');
        cta.disabled = false;
        console.error('[gcp] could not reach /cart/add.js', e, 'sent:', items);
        showErr(box, 'Could not reach the cart. Please try again.');
      });
  }

  // ---- listeners, bound once to document --------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var box = t.closest('[data-gcp-buybox]');
    if (!box) return;
    var mode = t.closest('.gcp-mode');
    if (mode) {
      setMode(box, mode);
      return;
    }
    var opt = t.closest('.gcp-opt');
    if (opt) {
      select(box, opt);
      return;
    }
    var cta = t.closest('[data-gcp-cta]');
    if (cta) addToCart(box);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var box = t.closest('[data-gcp-buybox]');
    if (!box) return;
    var opt = t.closest('.gcp-opt');
    if (!opt) return;
    var l = list(box, '.gcp-opt'),
      i = l.indexOf(opt),
      n;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      n = l[(i + 1) % l.length];
      n.focus();
      select(box, n);
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      n = l[(i - 1 + l.length) % l.length];
      n.focus();
      select(box, n);
    }
  });

  // Cosmetic only. The markup already ships in its default (checked) state,
  // so the box is correct even if this never runs. Safe to call repeatedly.
  function sync() {
    list(document, '[data-gcp-buybox]').forEach(function (box) {
      var c = currentOpt(box);
      if (c) render(box, c);
    });
  }

  sync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
})();
